export default __webpack_public_path__ + "static/media/GlassManufacturingImg.91d6e28e.jpg";